import { loadJs } from "./utilities";

const baseUrl = `https://cdn.qwtag.com/[UUID]/qw.js`;

const EVENTS = {
	YIELDBIRD_LOADED: 'mega.yieldbird.loaded'
}

export function load(callback:Function = ()=>{}) {
	const yieldbirdId = window?._mega?.publisher?.config?.yieldbird?.uuid || null;
	if(!yieldbirdId) {
		throw new Error('Yieldbird UUID not set')
	}
	const url = baseUrl.replace('[UUID]', yieldbirdId)
	loadJs(url, () => { dispatchEvent(new CustomEvent(EVENTS.YIELDBIRD_LOADED)), callback() })
}
